import { createResource } from 'react-resource-router/resources';

import type { ResourceContext } from '@townsquare/router/types';

export const staticConfigResource = createResource({
	type: 'AVP_STATIC_CONFIG',
	getKey: (_, resourceContext) => {
		const { workspace } = resourceContext as ResourceContext;
		if (!workspace) {
			// "no workspace" is a valid customer experience but this resource is not expected to work there
			return 'NO_WORKSPACE';
		}
		const { activationId } = workspace;
		return JSON.stringify({ activationId });
	},
	getData: async (_, resourceContext) => {
		const { workspace } = resourceContext as ResourceContext;
		if (!workspace) {
			// "no workspace" is a valid customer experience but this resource is not expected to work there
			return null;
		}
		const { activationId } = workspace;
		const response = await fetch(`/gateway/api/avp/embed/workspaceId/${activationId}/api/static-config`);
		if (!response.ok) {
			throw new Error('Failed to fetch static-config');
		}
		return await response.json();
	},
	maxAge: 60_000 * 5,
});
